





import {apiV1AdminNewsPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostEdit from '@/components/admin/PostEdit'
import Post, {IPost} from '@/models/Post'
import News from '@/models/News'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm
  }
})
export default class NewsEdit extends PostEdit {
  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminNewsPath(this.$route.params.id)
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new News(data)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'ニュース一覧',
        to: '/admin/news',
        exact: true
      },
      {
        text: 'ニュース編集'
      }
    ]
  }
}
